/**
 * Static how-to video list for the Resources screen (AO-04).
 * Frontend-only content per SoW; mirrors amatrium_mockup/src/data/mockData.js → resources.
 */

export interface ResourceItem {
  id: string;
  title: string;
  topic: string;
  duration: string;
  desc: string;
  /** Video/article link. When set, clicking the card opens it; otherwise a "coming soon" notice. */
  url?: string;
}

export const RESOURCES: ResourceItem[] = [
  {
    id: 'r1',
    title: 'How to use Chat',
    topic: 'Chat',
    duration: '3:12',
    desc: 'Ask questions and get source-cited answers from your company knowledge.',
    url: 'https://youtu.be/fKAJg5krBZE',
  },
  {
    id: 'r2',
    title: 'How to use Summary',
    topic: 'Summary',
    duration: '2:45',
    desc: 'Select up to 5 documents and generate a source-cited summary in your preferred language and length.',
    url: 'https://youtu.be/CoAvPmqEbWk',
  },
  {
    id: 'r3',
    title: 'How to use Translator',
    topic: 'Translator',
    duration: '2:08',
    desc: 'Translate documents, technical files, and engineering drawings into 100+ languages.',
    url: 'https://youtu.be/jdzyq0za39Q',
  },
  {
    id: 'r4',
    title: 'How to Upload Documents',
    topic: 'Knowledge base',
    duration: '4:01',
    desc: 'Add files to the knowledge base and track indexing status.',
    url: 'https://youtu.be/HI6ZUhxGkFc',
  },
  {
    id: 'r5',
    title: 'How to Sync SharePoint',
    topic: 'Administration',
    duration: '5:20',
    desc: 'Set up a connection and run your first sync (Admin only).',
    url: 'https://youtu.be/JX49ipszA1k',
  },
  {
    id: 'r6',
    title: 'Reading usage & members',
    topic: 'Administration',
    duration: '3:33',
    desc: 'Monitor co-worker usage by month and manage company members.',
    // Video coming soon — no url → card shows the "coming soon" notice.
  },
];
